import { AssignTable } from 'features/assigned-clients/components/assign-table/users-table';
import { AssignTopBar } from 'features/assigned-clients/components/top-bar/assign-top-bar';
import {
  UserFilterFormValues,
  UserFilterFormValuesPaginated,
} from 'features/users/components/users-filter-form/types';
import { usePaginationParams } from 'hooks';
import { Outlet } from 'react-router-dom';
const getInitialFilterValues: UserFilterFormValues = {
  full_user_name: undefined,
  phone_number: undefined,
  email: undefined,
  role: undefined,
  company_id: undefined,
};

export const AssignClientsView = () => {
  const { params, updateParams } =
    usePaginationParams<UserFilterFormValuesPaginated>({
      PageIndex: 1,
      RecordPerPage: 10,
      order_by: 'name',
      ...getInitialFilterValues,
    });

  const getUsersListQueryResponse: any = '';

  return (
    <>
      <AssignTopBar />
      <AssignTable
        isUsersListLoading={
          getUsersListQueryResponse.isLoading &&
          getUsersListQueryResponse.isFetching
        }
        usersList={'' as any}
        itemsCount={getUsersListQueryResponse.data?.total || 0}
        tableParams={params}
        updateParams={updateParams}
      />
      <Outlet />
    </>
  );
};
